export const environment = {
  production: true,
  brands: {
    enelx: {
      globalNavUrl: 'https://global-nav-v2.eis-svcs.enernoc.net/api/v2',
    },
  },
  cdn: 'https://cdn.apps.enelx.com',
  defaults: {
    brand: 'enelx',
    locale: 'en-us',
    apiLocale: 'en_US',
  },
};
